import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getProfileOwnerStats } from '../../../selectors/users';
import { getModuleType } from '../../../selectors/modules';
import {
  getAllInstalledModuleIds,
  getSectionLayoutVersion,
} from '../../../selectors/layout';
import { mapModuleTypeToWidgetComponent } from './AboutSection';

const section = 'about';
export default connect(
  (state: AppState, props) => {
    const stats = getProfileOwnerStats(state);
    const routes = getAllInstalledModuleIds(state, section)
      .map(moduleId => {
        const moduleType = getModuleType(state, moduleId);
        if (
          !moduleType ||
          !mapModuleTypeToWidgetComponent.hasOwnProperty(moduleType)
        ) {
          return;
        }
        return {
          key: `pages.about.navmenu.${moduleType}`,
          hash: moduleType,
        };
      })
      .filter(route => route);
    const layoutVersion = getSectionLayoutVersion(state, section);
    return {
      stats,
      routes,
      layoutVersion,
    };
  },
  {}
);
